import { useEffect, useState } from "react";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { _single, _UBLInvoice, _UBLItemInvoice } from "../../../../../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../../../theme/Component/ListMenu";
import { BasicTable, MASK_BOOLEAN, MASK_BOOLEAN_ICON, MASK_MONEY, MASK_NUMBER } from "../../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../../../theme/Component/ModalConfirm";
import { SelectProject } from "../../../../../../erp/cellEditor/BudgetAccountantOperation/SelectProject";
import { SelectBusinessCore } from "../../../../../../erp/cellEditor/BusinessCore/SelectBusinessCore";
import { SelectAccountantTree } from "../../../../../../contabilidad/catalogo-cuentas/AccountantTree/SelectAccountantTree";
import { InputMoney } from "../../../../../../theme/Input/InputMoney";
import { SelectProductEditor } from "../../../../../../Factoty&Production/ManufacturingStandars/Components/SelectProductEditor";
import { SelectorUmeasurement } from "../../../../../../bpm/config/Componentes/SelectorUmeasurement";
import { OBsBudgetEditor } from "./Component/OBsBudgetEditor";
import { TaxSchemeValueRadioSelectorByUBLItemInvoice } from "../../../ublinvoice/CreateUBLInvoice/TaxSchemeValueRadioSelectorByUBLItemInvoice";
import { CostingCenterEditor, CostingCenterValidation } from "../../CostingCenterEditor";
import useModal, { MODAL_md } from "../../../../../../theme/Component/hooks/useModal";
import { TaxableArticleTypesEditor } from "../../../../../../admin/ConfImpuestos/TaxScheme/FuncionesTaxScheme/TaxableArticleTypes.editor";
import { OBsEditor } from "../OBsEditor";
import { BasicSwitch } from "../../../../../../theme/Component/BasicSwitch";
import { SelectBudgetID } from "../../../../../../admin/configuracion/BudgetID/SelectBudgetID";
import { PrintJson } from "../../../../../../theme/Component/PrintJson";


interface Props {
    ublInvoce: any;
    idUBLInvoice: number;
    issueDate: Date;
    _onChange?: Function;
    lengthList?: Function;
    isCash?: boolean;
}

export const UBLInvoiceItemSupplier = ({ ublInvoce, idUBLInvoice, issueDate, _onChange, lengthList, isCash }: Props) => {

    const { instance, bean, setBean, lista, setLista, handleChange, addRequiredFields, isMissing, isRequired, validateForm } = useDataBean(_UBLItemInvoice);
    const { instance: instanceUBL, bean: beanUBL, setBean: setBeanUBL } = useDataBean(_UBLInvoice)

    const [taxApply, setTaxApply] = useState<any>([]);

    const [modalImpuestos, setModalImpuestos] = useState<any>({ name: 'Ver Impuestos', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const modalCostingCenter = useModal("Centro de costo", MODAL_md);
    const [costingCenterValidation, setCostingCenterValidation] = useState<CostingCenterValidation>({
        CostingCenterMethod: 0,
        isValid: true,
        percentValue: 100
    });
    const modalSetOB = useModal("Obligación", MODAL_md);

    useEffect(() => {
        if (idUBLInvoice) {
            getInvoice();
        }
    }, [idUBLInvoice])

    useEffect(() => {
        if (bean.OBIDDocument > 0)
            getProjectByOBDocument();
    }, [bean.OBIDDocument])

    const getInvoice = () => {
        instanceUBL.getUblInvoice(idUBLInvoice, issueDate).then(
            (resp) => {
                setBeanUBL(resp)
                getLista();
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }

    const generate = () => {

        let copy = { ...bean };
        console.log(copy);

        instance.createProductRowForUBLPurchaseInvoice14(bean.IDUBLInvoice, bean.IssueDate, bean.Quantity, bean.Description, bean.TotalItemAmount, bean.IDProduct, bean.IDMeasurementUnitCode,
            bean.BudgetID, bean.IDBudgetResource, bean.IDBudgetSource, bean.AccountantID, bean.CostingCenter, bean.IDProject, bean.IDBusinessCore, bean.AdquisitionArticleType).then(
                (resp) => {

                    if (copy.OBIDDocument) {
                        copy = { ...resp, OBMnemonic: copy.OBMnemonic, OBIDDocument: copy.OBIDDocument, OBConsecutive: copy.OBConsecutive, OBDate: copy.OBDate, OBDocumentState: copy.OBDocumentState, AccountantID: copy.AccountantID };
                        console.log("UPDATE => ", copy);

                        console.log(copy)

                        updateUBLItemInvoice2(copy);
                    } else {
                        getLista();
                        setModal({ ...modal, "view": false })
                        if (_onChange) {
                            _onChange();
                        }
                    }
                }
            ).catch(
                err => { toast.error(err) }
            );
    }

    const create = () => {
        setBean({
            IDUBLInvoice: idUBLInvoice,
            IssueDate: issueDate,
            AccountantID: beanUBL.AccountantIDStr,
            IDBusinessCore: beanUBL.IDBusinessCore,
            IDProject: beanUBL.IDProject
        })
        setModal({ ...modal, "view": true, "name": "Crear Item de Factura" })
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: () => { create() } }
    ]

    const getLista = () => {
        instance.getUBLItemInvoiceCatalog(idUBLInvoice, issueDate).then(
            (resp) => {

                let tmp = resp;
                tmp.forEach((element: any) => {
                    element.DataBeanProperties.RenderMethod = element.DataBeanProperties.CostingCenterMethod ? (returnValue(element.DataBeanProperties)) : "N/P";
                    element.DataBeanProperties.OBName = element.DataBeanProperties.OBMnemonic ? (element.DataBeanProperties.OBMnemonic ?? '') + " - " + (element.DataBeanProperties.OBConsecutive ?? '') : "N/P";
                });
                setLista(tmp)
            }
        )
    }

    const returnValue = (obj: any) => {
        if (obj.CostingCenterMethod === 2) return obj.CostingCenterName;
        if (obj.CostingCenterMethod === 3) return "N/A"
        if (obj.CostingCenterMethod === 4) return "N/A"
        if (obj.CostingCenterMethod === 5) return obj.CostingCenterDate
    }

    useEffect(() => {
        if (lengthList) {
            lengthList(lista.length)
        }
    }, [lista])

    const delteItem = () => {
        instance.deleteUBLItemInvoice(bean.IssueDate, bean.IDUBLItemInvoice).then(
            (resp) => {
                getLista();
                setModalC({ ...modalC, "view": false });
                if (_onChange) {
                    _onChange();
                }
            }
        )
    }

    const listaBotones = () => {
        const botones = [
            { titulo: 'Ajuste Contable', icono: 'ri-file-list-2-line', visible: true, evento: () => { setModalAjust({ ...modalAjust, "view": true }) } },
            { titulo: 'Agregar/Eliminar Impuestos', icono: 'ri-file-list-2-line', visible: true, evento: () => { setModalImpuestos({ ...modalImpuestos, "view": true }) } },
            { titulo: 'Definir Centro de Costo', icono: 'ri-file-list-2-line', visible: true, evento: openCostingCenterModal },
            { titulo: 'Editar Items', icono: 'ri-file-list-2-line', visible: true, evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar Item de la Factura', icono: 'ri-delete-bin-2-line', visible: ((bean.IsEditable || !bean.IsEditable)), evento: () => { setModalC({ ...modalC, "name": `Eliminar Item ${bean.Description}`, "view": true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const getProjectByOBDocument = () => {
        instance.getProjectByOBDocument(bean.OBIDDocument, bean.OBDate).then(
            (resp: any) => {
                console.log(resp);
                if (resp.IDProject) {
                    setBean({ ...bean, "IDProject": resp.IDProject });
                } else {
                    setBean({ ...bean, "IDProject": 0 });
                }

            }
        ).catch(err => console.error(err))
    }

    const head = [
        { title: 'ID', property: 'IDUBLItemInvoice', visible: false },
        { title: 'Nombre del Bien o Servicio', property: 'Description', visible: true },
        { title: 'Metodo', property: 'CostingCenterMethodName', visible: true },
        { title: 'Dato del Metodo', property: 'RenderMethod', visible: true },
        // { title: 'Fecha de corte', property: 'CostingCenterDate', visible: true },
        { title: 'Valor Unitario', property: 'UnitaryValue', visible: true, mask: MASK_MONEY },
        { title: 'Cantidad', property: 'Quantity', visible: true },
        { title: 'Subtotal', property: 'PriceValue', visible: true, mask: MASK_MONEY },
        { title: 'Subtotal Impuestos', property: 'TaxAmount', visible: true, mask: MASK_MONEY },
        { title: 'Impuestos de Valor Agregado Mayor Valor del Costo', property: 'AddedTaxHigherValue', visible: true, mask: MASK_BOOLEAN },
        { title: 'Tipo de Artículo', property: 'AdquisitionArticleTypeName', visible: true },
        { title: 'Clasificación Almacén', property: 'AssetTypeName', visible: true },
        { title: 'Valor Total', property: 'TotalItemAmount', visible: true, mask: MASK_MONEY },
        { title: 'Ciudad de Bien/Servicio', property: 'SiteIDName', visible: false },
        { title: 'Obligación', property: 'OBName', visible: true },
        { title: 'Cuenta Contable', property: 'AccountantIDName', visible: true },
        { title: 'Rubro Presupuestal', property: 'BudgetID', visible: true },
        { title: 'Tipo de Bien', property: 'AssetTypeName', visible: false },
    ]

    useEffect(() => {
        let requiredFields = [
            "Quantity", "Description", "TotalItemAmount", "AccountantID", "AdquisitionArticleType"
        ];

        if (beanUBL.PaymentType === 17) {
            requiredFields = requiredFields.concat(["OBIDDocument", "BudgetID"]);
        } else {
            requiredFields = requiredFields.concat(["IDProject", "IDBusinessCore"]);
        }


        addRequiredFields(requiredFields);
    }, [beanUBL.PaymentType]);

    const validateData = () => {
        if (!validateForm()) {
            toast.error("Faltan Campos Obligatorios por diligenciar");
            return;
        }

        if (bean.IDUBLItemInvoice > 0) {
            updateUBLItemInvoice();
        } else {
            generate();
        }
    }

    const updateTaxItem = () => {
        instance.parseTaxSchemaValuesForUBLInvoiceItem(bean.IDUBLItemInvoice, issueDate, taxApply).then(
            (resp) => {
                setModalImpuestos({ ...modalImpuestos, "view": false });
                getLista();
            }
        )
    }
    const updateUBLItemInvoice = () => {
        instance.updateUBLItemInvoice(bean).then((resp: any) => {

            getLista();
            modalCostingCenter.close();
            modalSetOB.close();
            setModal({ ...modal, "view": false });
            setModalAjust({ ...modalAjust, "view": false })
        }).catch(err => { toast.error(err) })
    }

    const updateUBLItemInvoice2 = (b: any) => {
        instance.updateUBLItemInvoice(b).then((resp: any) => {
            getLista();
            setModal({ ...modal, "view": false })
            if (_onChange) {
                _onChange();
            }
        }).catch(err => { toast.error(err) })
    }

    const updateCostingCenter = (e: any) => {
        setBean((current: any) => ({ ...current, ...e }));
    }

    const getCurrentCostingCenterValidation = (): CostingCenterValidation => {
        if (bean.CostingCenterMethod === 2) {
            return {
                CostingCenterMethod: 2,
                isValid: Boolean(bean.CostingCenter),
                message: "Debe seleccionar un centro de costo."
            }
        }

        if (bean.CostingCenterMethod === 3) {
            return {
                CostingCenterMethod: 3,
                isValid: Boolean(bean.IDCostingCenterMethod),
                percentValue: bean.IDCostingCenterMethod ? 100 : 0,
                message: "Debe seleccionar un metodo de costeo completo."
            }
        }

        if (bean.CostingCenterMethod === 4) {
            return {
                CostingCenterMethod: 4,
                isValid: false,
                percentValue: 0,
                message: "Debe completar la distribucion de centro de costo."
            }
        }

        if (bean.CostingCenterMethod === 5) {
            return {
                CostingCenterMethod: 5,
                isValid: Boolean(bean.CostingCenterDate),
                message: "Debe seleccionar una fecha de corte."
            }
        }

        return {
            CostingCenterMethod: bean.CostingCenterMethod ?? 0,
            isValid: true,
            percentValue: 100
        }
    }

    const openCostingCenterModal = () => {
        setCostingCenterValidation(getCurrentCostingCenterValidation());
        modalCostingCenter.open();
    }

    const updateCostingCenterModal = () => {
        if (!costingCenterValidation.isValid) {
            toast.warning(costingCenterValidation.message ?? ("El metodo de costeo esta incompleto en su porcentaje : " + (costingCenterValidation.percentValue ?? 0) + "%"));
            return;
        }

        updateUBLItemInvoice();
    }

    const [modalAjust, setModalAjust] = useState<any>({ name: "Ajuste Contable", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    return (
        <div className="row">
            <div className="col-md-12">
                <div className="row">
                    <div className="col-md-6">
                        <strong>Proveedor </strong><small>{beanUBL.AccountSupplierName}</small>
                    </div>
                    <div className="col-md-6">
                        <strong>Idenficación </strong><small>{beanUBL.AccountSupplierNit}</small>
                    </div>
                    <div className="col-md-6">
                        <strong>Concepto </strong><small>{beanUBL.AccountantConceptName}</small>
                    </div>
                    <div className="col-md-6">
                        <strong>ID Factura </strong><small>{beanUBL.IDUBLInvoice}</small>
                    </div>
                    <div className="col-md-6">
                        <strong>Fecha Factura </strong><small>{beanUBL.IssueDate}</small>
                    </div>
                </div>

                <BasicTable cssTable="table-responsive2" listButtons={listaBotones()} iconButtons={iconButtonsItem} body={lista} head={head} rowSet={setBean} />

                <Modal modal={modal} updateModal={setModal} eventModal={validateData} >
                    <div className="row">
                        {isCash ?
                            <div className="col-md-6">
                                <SelectBudgetID jsonCode={bean.BudgetID} edit={false} label={'Rubro'} onChange={(e) => { setBean({ ...bean, "BudgetIDStr": e.JsonCode, "BudgetID": e.JsonCode }) }} />
                            </div>
                            :
                            <>
                                {beanUBL.PaymentType === 17 &&
                                    <>
                                        <div className="col-md-6">
                                            <label className={`${isMissing('OBIDDocument') ? 'has-error' : ''}`}>Obligación Presupuestal {isRequired('OBIDDocument') ? <span className="text-danger">*</span> : ''}</label>
                                            <OBsEditor idDocument={bean.OBIDDocument} configProps={{ label: " " }} idAccount={ublInvoce.IDAccountSupplier} paymentDate={ublInvoce.AccountantDate}
                                                onChange={(e) => {
                                                    console.log(e)
                                                    setBean({
                                                        ...bean,
                                                        "OBIDDocument": e.IDDocument,
                                                        "OBMnemonic": e.Mnemonic,
                                                        "OBConsecutive": e.Consecutive,
                                                        "OBDate": e.DocumentDate,
                                                        "OBDocumentState": e.DocumentSate,
                                                        "TotalItemAmount": bean.TotalItemAmount ?? e.OBValue,
                                                        "Quantity": 1,
                                                    })
                                                }} />
                                        </div>
                                        <div className="col-md-6">
                                            <label className={`${isMissing('BudgetID') ? 'has-error' : ''}`}>Rubro Presupuestal {isRequired('BudgetID') ? <span className="text-danger">*</span> : ''}</label>
                                            <OBsBudgetEditor renderValue={bean.BudgetName} _paymentDate={bean.OBDate} configProps={{ label: " " }} idDocument={bean.OBIDDocument}
                                                onChange={(e) => {
                                                    console.log(e)
                                                    setBean({ ...bean, "BudgetID": e.BudgetIDStr, "IDBudgetResource": e.IDBudgetResource, "IDBudgetSource": e.IDBudgetSource })
                                                }} />
                                        </div>
                                    </>
                                }

                            </>
                        }

                        <div className="col-md-6">
                            <label className={`${isMissing('Quantity') ? 'has-error' : ''}`}>Cantidad {isRequired('Quantity') ? <span className="text-danger">*</span> : ''}</label>
                            <input type="number" className="form-control" value={bean.Quantity} onChange={(e) => { setBean({ ...bean, "Quantity": e.target.value }) }} />
                        </div>

                        <div className="col-md-6">
                            <label className={`${isMissing('TotalItemAmount') ? 'has-error' : ''}`}>Valor Total {isRequired('TotalItemAmount') ? <span className="text-danger">*</span> : ''}</label>
                            <InputMoney _value={bean.TotalItemAmount} onChange={(e) => { setBean({ ...bean, "TotalItemAmount": e }) }} _label=" " />
                        </div>

                        <div className="col-md-6">
                            <SelectProductEditor label="Producto" value={bean.IDProduct} onChange={(e) => { setBean({ ...bean, "IDProduct": e.IDProduct }) }} />
                        </div>

                        <div className="col-md-6">
                            <SelectorUmeasurement titulo='Unidad de Medida' idSelector={bean.IDMeasurementUnitCode} onChange={(e) => { setBean({ ...bean, "IDMeasurementUnitCode": e }) }} />
                        </div>

                        <div className="col-md-6">
                            <label className={`${isMissing('AccountantID') ? 'has-error' : ''}`}>Cuenta Contable {isRequired('AccountantID') ? <span className="text-danger">*</span> : ''}</label>
                            <SelectAccountantTree disabled={bean.RequiresAccountantID === false} label=" " jsonCode={bean.AccountantID ?? beanUBL.AccountantIDStr} onChange={(e) => setBean({ ...bean, "AccountantID": e.JsonCode })} />
                        </div>

                        <div className="col-md-6">
                            <label className={`${isMissing('IDProject') ? 'has-error' : ''}`}>Proyecto {isRequired('IDProject') ? <span className="text-danger">*</span> : ''}</label>
                            <SelectProject label=" " idSelector={bean.IDProject ?? beanUBL.IDProject} onChange={(e) => { setBean({ ...bean, "IDProject": e }) }} />
                        </div>

                        <div className="col-md-6">
                            <label className={`${isMissing('IDBusinessCore') ? 'has-error' : ''}`}>Línea de Negocio {isRequired('IDBusinessCore') ? <span className="text-danger">*</span> : ''}</label>
                            <SelectBusinessCore returnType="ID" idSelector={bean.IDBusinessCore ?? beanUBL.IDBusinessCore} label=" " onChange={(e) => { setBean({ ...bean, "IDBusinessCore": e }) }} />
                        </div>


                        <div className="col-md-6">
                            <label className={`${isMissing('AdquisitionArticleType') ? 'has-error' : ''}`}>Tipo de Articulo {isRequired('AdquisitionArticleType') ? <span className="text-danger">*</span> : ''}</label>
                            <TaxableArticleTypesEditor label=" " idSelector={bean.AdquisitionArticleType} onChange={(e) => setBean({ ...bean, "AdquisitionArticleType": e })} />
                        </div>

                        <div className="col-md-6">
                            <BasicSwitch label="Impuestos de Valor Agregado Mayor Valor del Costo " estado={(bean.AddedTaxHigherValue ?? false)} eventChange={(e) => { setBean({ ...bean, "AddedTaxHigherValue": e }) }} />
                        </div>

                        <div className="col-md-12">
                            <label className={`${isMissing('Description') ? 'has-error' : ''}`}>Descripción {isRequired('Description') ? <span className="text-danger">*</span> : ''}</label>
                            <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, "Description": e.target.value }) }}></textarea>
                        </div>

                    </div>
                </Modal>

                <Modal modal={modalImpuestos} updateModal={setModalImpuestos} eventModal={() => { updateTaxItem() }} >
                    <TaxSchemeValueRadioSelectorByUBLItemInvoice _UBLinvsourceType={beanUBL.SourceType} idUBLItem={bean.IDUBLItemInvoice} issueDate={issueDate} onChange={(e) => { setTaxApply(e) }} />
                </Modal>

                <Modal modal={modalCostingCenter.modal} updateModal={modalCostingCenter.setModal} eventModal={updateCostingCenterModal}>
                    <CostingCenterEditor
                        label="Centro de costo"
                        idCostingCenterMethod={bean.CostingCenterMethod}
                        costingCenterLabel={bean.CostingCenterMethodName}
                        dataInput={bean}
                        onChange={updateCostingCenter}
                        onValidationChange={setCostingCenterValidation}
                    />
                </Modal>

                <Modal modal={modalSetOB.modal} updateModal={modalSetOB.setModal} eventModal={updateUBLItemInvoice}>
                    <div className="row">
                        <div className="col-md-6">
                            <label className={`${isMissing('OdIDocument') ? 'has-error' : ''}`}>Obligación Presupuestal {isRequired('OdIDocument') ? <span className="text-danger">*</span> : ''}</label>
                            <OBsEditor idDocument={bean.OBIDDocument} configProps={{ label: " " }} idAccount={ublInvoce.IDAccountSupplier} paymentDate={ublInvoce.AccountantDate}
                                onChange={(e) => {
                                    setBean({
                                        ...bean,
                                        "OBIDDocument": e.IDDocument,
                                        "OBMnemonic": e.Mnemonic,
                                        "OBConsecutive": e.Consecutive,
                                        "OBDate": e.Since,
                                        "OBDocumentState": e.DocumentSate,
                                    })
                                }} />
                        </div>
                    </div>
                </Modal>

                <ModalConfirm eventModal={delteItem} modal={modalC} updateModal={setModalC}>
                    <p>Eliminar Item</p>
                </ModalConfirm>

                <Modal modal={modalAjust} updateModal={setModalAjust} eventModal={updateUBLItemInvoice} >
                    <div className="col-12">
                        <label >Ajuste Contable</label>
                        <input type="number" className="form-control" value={bean.AccountingAdjustmentValue} onChange={(e) => { setBean({ ...bean, "AccountingAdjustmentValue": e.target.value }) }} />
                    </div>
                </Modal>
            </div>
        </div>
    )
}
